export default "__VITE_ASSET__f3lisFpf__"